import { render, staticRenderFns } from "./IndexNotice.vue?vue&type=template&id=5c7ee1ff"
import script from "./IndexNotice.vue?vue&type=script&lang=js"
export * from "./IndexNotice.vue?vue&type=script&lang=js"
import style0 from "./IndexNotice.vue?vue&type=style&index=0&id=5c7ee1ff&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports